export const DRAWER_MEDIA_MAPPER = media => ({
  xs: media.xs || media.sm || media.md,
  sm: false,
  md: media.lg || media.xl || media.xxl,
  lg: false,
  xl: false,
  xxl: false,
});
